import React, { useEffect, useState } from "react";

function ScrollButton() {
  const [mostrarBoton, setMostrarBoton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const posicion = window.scrollY;
      setMostrarBoton(posicion > 500);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const irArriba = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`fixed left-1/2 bottom-8 transform -translate-x-1/2 z-50 transition-all duration-200 ${
        mostrarBoton ? "block" : "hidden"
      }`}
    >
      <button
        className="p-3 rounded-full bg-zinc-500 opacity-75 border border-zinc-500 hover:bg-zinc-400 hover:border-gray-100 transition-all duration-200"
        onClick={irArriba}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-arrow-narrow-up"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="#ffffff"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 5l0 14" />
          <path d="M16 9l-4 -4" />
          <path d="M8 9l4 -4" />
        </svg>
      </button>
    </div>
  );
}

export default ScrollButton;
